import { Dialog } from 'primereact/dialog';
import CalendarComponent from '../CalendarComponent/CalendarComponent';

interface ComponentProps {
  close: () => void;
  dialogVisible: boolean;
}

/**
 * @author noone
 */
const DialogCalendarComponent: React.FC<ComponentProps> = (props) => {

  return (
    <Dialog
      visible={props.dialogVisible}
      onHide={() => props.close()}
      header={"Dialog Kalendar"}
      modal
      style={{ width: '100vw', height: '100vw', position: 'fixed', bottom: 0, left: 0, top: 'auto' }}
    >
      <CalendarComponent />
    </Dialog>
  );

}

export default DialogCalendarComponent;